<template>
  <div class="ui form" ref="form">
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <div class="field">
        <label for>{{ $t("project") }}</label>
        <select
          name="project"
          class="ui fluid search dropdown"
          v-model="setup.project"
          ref="project_dropdown"
        ></select>
      </div>
      <div class="field">
        <label for>{{ $t("url") }}</label>
        <input type="text" name="url" v-model="setup.url" />
      </div>
    </div>
    <div class="field">
      <label for>{{ $t("description") }}</label>
      <textarea name rows="2" v-model="setup.description"></textarea>
    </div>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";

export default {
  name: "General",
  components: {},
  props: {
    endpoint_in: Object,
    projects: Array,
  },
  computed: {},
  data() {
    return {
      setup: {
        name: "",
        url: "",
        project: "",
        description: "",
      },
    };
  },
  methods: {
    getData() {
      return this.setup;
    },
    isValid() {
      return window.jQuery(this.$refs.form).form("validate form");
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        url: ["empty"],
      },
    });

    if (!isEmpty(this.endpoint_in)) this.setup = this.endpoint_in.setup.general;

    if (vm.projects && vm.projects.length) {
      let vls = vm.projects.map((p) => {
        return { name: p, value: p };
      });

      setTimeout(() => {
        window
          .jQuery(vm.$refs.project_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            allowAdditions: true,
          });

        if (vm.setup.project) {
          window
            .jQuery(vm.$refs.project_dropdown)
            .dropdown("set selected", vm.setup.project)
            .dropdown({
              allowAdditions: true,
            });
        }
      }, 500);
    }
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
